document.addEventListener('DOMContentLoaded', () => {
  // accordion for mobile header and footer
  const accordionItem = document.querySelectorAll('.byteex-accordion-item');
  accordionItem.forEach(item => {
    const accordionIcon = item.querySelector('.byteex-accordion-icon');
    const plusIcon = accordionIcon.dataset.plus;
    const minusIcon = accordionIcon.dataset.minus;
    const content = item.nextElementSibling;
  
    item.addEventListener("click", function () {
      if (!content) return;
  
      const isVisible = window.getComputedStyle(content).display === "block";
  
      if (isVisible) {
        content.style.display = "none";
        accordionIcon.src = plusIcon;
      } else {
        content.style.display = "block";
        accordionIcon.src = minusIcon;
      }
    });
  });
  /*const accordionItem = document.querySelectorAll('.byteex-accordion-item');
  accordionItem.forEach(item => {
    const accordionIcon = item.querySelector('.byteex-accordion-icon');
    const plusIcon = accordionIcon.dataset.plus;
    const minusIcon = accordionIcon.dataset.minus;
    const content = item.nextElementSibling;    

    item.addEventListener("click", function () {
      if (content.style.display === "block") {
        content.style.display = "none";
        accordionIcon.src = plusIcon;
      } else {
        content.style.display = "block";
        accordionIcon.src = minusIcon;
      }
    });
  }); */

  
  
  // Support GorgiasChat Header
  const open_support_chat_button = document.querySelectorAll('.open-support-chat');
  open_support_chat_button.forEach(item => {
    item.addEventListener('click', () => {
      GorgiasChat.open();

      const chatButton = document.getElementById('custom_chat_button');
      if (chatButton) {
        chatButton.style.height = '60px';
        chatButton.style.width = '60px';
        chatButton.style.padding = '16px 20px';

        chatButton.addEventListener('click', function () {
          hideChatButton();
        });

        function hideChatButton() {
          chatButton.style.height = '0';
          chatButton.style.width = '0';
          chatButton.style.padding = '0';
        }
      }      
    });
  });

  // Support GorgiasChat Footer
  const contactLinks = document.querySelectorAll(".contact-trigger");
  const closeButton = document.getElementById("custom_chat_button");

  if (contactLinks) {
    contactLinks.forEach(contactLink => {
      contactLink.addEventListener("click", (event) => {
        event.preventDefault();

        if (typeof GorgiasChat !== "undefined" && GorgiasChat.open) {
          GorgiasChat.open();
          setTimeout(() => {
            closeButton.style.visibility="visible";
            closeButton.style.opacity = "1";
          }, 1000);
        } else {
          console.error("GorgiasChat is not defined or not loaded.");
        }
      });
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      closeButton.style.visibility = "hidden";
      closeButton.style.opacity = "0";

      if (typeof GorgiasChat !== "undefined" && GorgiasChat.close) {
        GorgiasChat.close();
      }
    });
  }
});
